import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MediaState } from 'common/store/genesys-cloud/conversations/messages/models/message-media-state.enum';
import { FileUploadState } from '../genesys-chat-footer/genesys-chat-file-upload.store';

@Component({
  selector: 'app-genesys-chat-file-upload-box',
  templateUrl: './genesys-chat-file-upload-box.component.html',
  styleUrls: ['./genesys-chat-file-upload-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatFileUploadBoxComponent {
  readonly mediaState = MediaState;

  @Input()
  fileUploadState: FileUploadState;

  @Output()
  deleteFile = new EventEmitter<void>();

  @Output()
  sendMedia = new EventEmitter<string>();

  canSendFile(): boolean {
    return this.fileUploadState?.mediaId && this.fileUploadState.status === MediaState.Valid;
  }

  showFileUploadBox(): boolean {
    return this.fileUploadState?.file && (this.fileUploadState?.status === this.mediaState.Valid || this.fileUploadState?.status === this.mediaState.Uploading);
  }

  showFileUploadErrorBox(): boolean {
    return this.fileUploadState?.file && (this.fileUploadState?.status === this.mediaState.Invalid);
  }
}
